export const flatStringArray = (stringArray: (string | RegExp)[]) =>
  stringArray.reduce((acc: (string | RegExp)[], curr) => {
    if (typeof curr === 'string') {
      return [...acc, ...curr.split('')];
    }
    return [...acc, curr];
  }, []);
